module.exports = __webpack_public_path__ + "static/media/son_pour_toi.e7b4ae74.mp3";